/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateInviteRoleRequestBody,
  UpdateInviteRoleRequestBody$Outbound,
  UpdateInviteRoleRequestBody$outboundSchema,
} from "../components/updateinviterolerequestbody.js";

export type UpdateInviteRoleSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateInviteRoleRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateInviteRoleRequestBody: UpdateInviteRoleRequestBody;
};

/** @internal */
export type UpdateInviteRoleSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateInviteRoleSecurity$outboundSchema: z.ZodMiniType<
  UpdateInviteRoleSecurity$Outbound,
  UpdateInviteRoleSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateInviteRoleSecurityToJSON(
  updateInviteRoleSecurity: UpdateInviteRoleSecurity,
): string {
  return JSON.stringify(
    UpdateInviteRoleSecurity$outboundSchema.parse(updateInviteRoleSecurity),
  );
}

/** @internal */
export type UpdateInviteRoleRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateInviteRoleRequestBody: UpdateInviteRoleRequestBody$Outbound;
};

/** @internal */
export const UpdateInviteRoleRequest$outboundSchema: z.ZodMiniType<
  UpdateInviteRoleRequest$Outbound,
  UpdateInviteRoleRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateInviteRoleRequestBody: UpdateInviteRoleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateInviteRoleRequestBody: "UpdateInviteRoleRequestBody",
    });
  }),
);

export function updateInviteRoleRequestToJSON(
  updateInviteRoleRequest: UpdateInviteRoleRequest,
): string {
  return JSON.stringify(
    UpdateInviteRoleRequest$outboundSchema.parse(updateInviteRoleRequest),
  );
}
